import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/Hero";
import { IntroSection } from "./components/IntroSection";
import { BeforeAfterSection } from "./components/BeforeAfterSection";
import { SituationsSection } from "./components/SituationsSection";
import { VolumesSection } from "./components/VolumesSection";
import { ResourcesSection } from "./components/ResourcesSection";
import { BonusesSection } from "./components/BonusesSection";
import { CollectionSection } from "./components/CollectionSection";
import { OfferSection } from "./components/OfferSection";
import { GuaranteeSection } from "./components/GuaranteeSection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { AuthorSection } from "./components/AuthorSection";
import { FaqSection } from "./components/FaqSection";
import { FinalCtaSection } from "./components/FinalCtaSection";
import { SiteFooter } from "./components/SiteFooter";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="w-full overflow-x-hidden bg-white font-sans text-ink" data-id="element-0" data-mp="3mk83wrqn3zad">
      <MetaPixel data-id="element-1" data-mp="3rbznujfaj6rj" />
      <Hero data-id="element-2" data-mp="3rdkh85pvcjnt" />
      <main data-id="element-3" data-mp="3rd1azm9kzjpm">
        <IntroSection data-id="element-4" data-mp="3reccfffk0fdk" />
        <BeforeAfterSection data-id="element-5" data-mp="5ot150vj28n" />
        <SituationsSection data-id="element-6" data-mp="4wv3njt0sf7" />
        <VolumesSection data-id="element-7" data-mp="56mnfkhz7n0" />
        <ResourcesSection data-id="element-8" data-mp="7sxpp6lk59z" />
        <BonusesSection data-id="element-9" data-mp="2zlli5ahfl0qy" />
        <CollectionSection data-id="element-10" data-mp="2zmenq84nlk7i" />
        <OfferSection data-id="element-11" data-mp="2zn6bwxvx8fnr" />
        <GuaranteeSection data-id="element-12" data-mp="33mf2xuzktzfm" />
        <TestimonialsSection data-id="element-13" data-mp="33lx18iu5at0b" />
        <AuthorSection data-id="element-14" data-mp="33mymfg4vkvvr" />
        <FaqSection data-id="element-15" data-mp="33oi152avuyvf" />
        <FinalCtaSection data-id="element-16" data-mp="38l8hzruihyhw" />
      </main>
      <SiteFooter data-id="element-17" data-mp="38k6tolohjfi8" />
      <FloatingCta data-id="element-18" data-mp="38nup5qdhqbzl" />
      <PurchasePopup data-id="element-19" data-mp="3dkuu1xylt8p4" />
    </div>;
}